/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import get from 'lodash.get';
import type { ThemeProps } from '../../types/shared';
import type { SpacingVars } from '../../types/theme';

export const getResponsiveSpacing =
  /* eslint-disable @typescript-eslint/no-redundant-type-constituents */

  (size: keyof SpacingVars | string = '') =>
    (styledComponentProps: ThemeProps): string => {
      const spacing = get(
        styledComponentProps,
        `theme.responsive.spacing.${size.toLowerCase()}`,
      ) as string | undefined;
      if (spacing) {
        return `var(${spacing})`;
      }

      const fallbackSpacing = get(styledComponentProps, `theme.spacing.${size.toLowerCase()}`) as
        | string
        | undefined;
      if (fallbackSpacing) {
        return `var(${fallbackSpacing})`;
      }

      return '';
    };
